import { render, staticRenderFns } from "./ViewProcess.vue?vue&type=template&id=71b3a6b4&scoped=true"
import script from "./ViewProcess.vue?vue&type=script&lang=js"
export * from "./ViewProcess.vue?vue&type=script&lang=js"
import style0 from "./ViewProcess.vue?vue&type=style&index=0&id=71b3a6b4&prod&scoped=true&lang=css"
import style1 from "./ViewProcess.vue?vue&type=style&index=1&id=71b3a6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3a6b4",
  null
  
)

export default component.exports